import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'userStatus',
    serviceName: 'auth',
    query: gql`
      query userStatus($ids: [String]) {
        userStatus(ids: $ids) {
          data {
            id
            title
            media {
              id
              full_url
            }
          }
          total
        }
      }
    `,
  },
};

export default schema;
